<div class="flex flex-col lg:flex-row gap-6">
  <!-- ═══ COLUMNA IZQUIERDA: Formulario ═══ -->
  <div class="flex-1 min-w-0 space-y-5">
    <!-- Error -->
    @if (error) {
      <div
        class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
      >
        <div class="flex items-center gap-3">
          <svg
            class="w-5 h-5 text-error-500 shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
        </div>
      </div>
    }

    <!-- Contacto (typeahead) -->
    <div>
      <label
        class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
      >
        Contacto
        <span class="text-gray-400 font-normal text-xs">(opcional)</span>
      </label>
      <div class="relative">
        <input
          type="text"
          [value]="contactSearchTerm"
          (input)="onContactSearchInput($any($event.target).value)"
          (keydown.enter)="onContactSearchEnter($event)"
          (blur)="closeContactDropdown()"
          autocomplete="off"
          placeholder="Buscar contacto... (Enter para ver todos)"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
        />
        @if (searchingContacts) {
          <div class="absolute right-3 top-3.5">
            <div
              class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
            ></div>
          </div>
        }
        @if (contactId) {
          <div class="absolute right-3 top-3.5 text-success-500">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        }
        @if (showContactDropdown && contactSearchResults.length > 0) {
          <div
            class="absolute z-10 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900 max-h-48 overflow-y-auto"
            (scroll)="onContactDropdownScroll($event)"
          >
            @for (c of contactSearchResults; track c.id) {
              <button
                type="button"
                (mousedown)="selectContact(c)"
                class="w-full px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
              >
                <span
                  class="block text-sm font-medium text-gray-900 dark:text-white"
                >
                  {{ c.fullname }} {{ c.lastname || '' }}
                </span>
                <span class="block text-xs text-gray-500 dark:text-gray-400">{{
                  c.mail
                }}</span>
              </button>
            }
            @if (loadingMoreContacts) {
              <div class="flex justify-center items-center py-2">
                <div
                  class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
                ></div>
                <span class="ml-2 text-xs text-gray-400 dark:text-gray-500"
                  >Cargando más...</span
                >
              </div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Correo electrónico -->
    <div>
      <div class="flex items-center gap-2 mb-1.5">
        <label
          class="block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Correo electrónico <span class="text-error-500">*</span>
        </label>
        @if (mailAutoFilled) {
          <span
            class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-success-100 text-success-700 dark:bg-success-500/20 dark:text-success-400 animate-pulse"
          >
            <svg
              class="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            Auto-completado
          </span>
        }
      </div>
      <input
        type="email"
        name="mail"
        [(ngModel)]="mail"
        (input)="mailAutoFilled = false"
        (ngModelChange)="onPreviewInputChange()"
        placeholder="usuario@correo.com"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:outline-hidden focus:ring-3 dark:text-white/90 dark:placeholder:text-white/30 transition-all duration-500"
        [class.border-success-400]="mailAutoFilled"
        [class.bg-success-50]="mailAutoFilled"
        [class.ring-success-500\/20]="mailAutoFilled"
        [class.focus:border-success-400]="mailAutoFilled"
        [class.border-gray-300]="!mailAutoFilled"
        [class.focus:border-brand-300]="!mailAutoFilled"
        [class.focus:ring-brand-500\/10]="!mailAutoFilled"
        [class.dark:border-gray-700]="!mailAutoFilled"
        [class.dark:bg-gray-900]="!mailAutoFilled"
        [class.dark:focus:border-brand-800]="!mailAutoFilled"
      />
    </div>

    <!-- Rol -->
    <div>
      <label
        class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
      >
        Rol <span class="text-error-500">*</span>
      </label>
      <select
        name="roleId"
        [(ngModel)]="roleId"
        (ngModelChange)="onPreviewInputChange()"
        [disabled]="rolesLoading"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <option [ngValue]="null">
          {{ rolesLoading ? 'Cargando...' : '— Seleccionar rol —' }}
        </option>
        @for (role of roles; track role.id) {
          <option [ngValue]="role.id">{{ role.name }}</option>
        }
      </select>
    </div>

    <!-- Fecha de expiración -->
    <div>
      <label
        class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
      >
        Expira el
        <span class="text-gray-400 font-normal text-xs"
          >(opcional · por defecto +7 días)</span
        >
      </label>
      <input
        type="datetime-local"
        name="expiresAt"
        [(ngModel)]="expiresAt"
        (ngModelChange)="onPreviewInputChange()"
        [min]="minExpiresAt"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 border-gray-300 [color-scheme:light] dark:[color-scheme:dark]"
      />
    </div>

    <!-- Plantilla de correo -->
    <div>
      <label
        class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
      >
        Plantilla de correo
        <span class="text-gray-400 font-normal text-xs">(opcional)</span>
      </label>
      <select
        name="templateId"
        [ngModel]="templateId"
        (ngModelChange)="onTemplateChange($event)"
        [disabled]="templatesLoading"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <option [ngValue]="null">
          {{
            templatesLoading ? 'Cargando...' : '— Usar plantilla por defecto —'
          }}
        </option>
        @for (tpl of templates; track tpl.id) {
          <option [ngValue]="tpl.id">
            {{ tpl.name }}{{ tpl.isDefault ? ' (default)' : '' }}
          </option>
        }
      </select>
    </div>

    <!-- Buttons -->
    <div
      class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700"
    >
      <app-button
        variant="outline"
        type="button"
        (btnClick)="cancelar()"
      >
        Cancelar
      </app-button>
      <app-button
        variant="primary"
        type="button"
        [disabled]="saving || !mail || !roleId"
        (btnClick)="guardar()"
      >
        {{ saving ? 'Enviando...' : 'Enviar invitación' }}
      </app-button>
    </div>
  </div>

  <!-- ═══ COLUMNA DERECHA: Vista previa del correo ═══ -->
  <div class="lg:w-[420px] lg:flex-shrink-0">
    @if (selectedTemplate) {
      <div class="sticky top-0">
        <div class="flex items-center gap-2 mb-3">
          <svg
            class="w-4 h-4 text-gray-500 dark:text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <span class="text-sm font-medium text-gray-700 dark:text-gray-300"
            >Vista previa del correo</span
          >
        </div>

        <div
          class="rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden"
        >
          <!-- Email header -->
          <div
            class="bg-gray-50 dark:bg-gray-800 px-4 py-3 border-b border-gray-200 dark:border-gray-700 space-y-1"
          >
            <div class="flex items-start gap-2">
              <span
                class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide shrink-0 pt-0.5"
                >Asunto:</span
              >
              <span class="text-sm text-gray-800 dark:text-white/90">{{
                previewSubject || selectedTemplate.subject
              }}</span>
            </div>
            <div class="flex items-center gap-2">
              <span
                class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide shrink-0"
                >Para:</span
              >
              <span class="text-sm text-gray-600 dark:text-gray-300 truncate">{{
                mail || 'usuario@correo.com'
              }}</span>
            </div>
            @if (selectedTemplate.stylePreset) {
              <div class="flex items-center gap-2">
                <span
                  class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide shrink-0"
                  >Estilo:</span
                >
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-brand-50 text-brand-600 dark:bg-brand-500/10 dark:text-brand-400"
                >
                  {{ selectedTemplate.stylePreset }}
                </span>
              </div>
            }
          </div>

          <!-- Email body: HTML final del backend (idéntico al correo real), aislado en iframe -->
          <div class="relative bg-white">
            @if (previewLoading) {
              <div class="flex items-center justify-center gap-2 py-16">
                <div
                  class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"
                ></div>
                <span class="text-xs text-gray-500 dark:text-gray-400"
                  >Generando vista previa...</span
                >
              </div>
            } @else if (previewError) {
              <div
                class="flex flex-col items-center justify-center gap-2 py-12 px-4 text-center"
              >
                <svg
                  class="w-6 h-6 text-error-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p class="text-xs text-error-500 dark:text-error-400">
                  {{ previewError }}
                </p>
              </div>
            } @else if (previewSafeHtml) {
              <iframe
                [srcdoc]="previewSafeHtml"
                class="w-full h-[460px] border-0 bg-white"
                sandbox
                title="Vista previa del correo"
              >
              </iframe>
            } @else {
              <div
                class="py-16 text-center text-xs text-gray-400 dark:text-gray-500"
              >
                Vista previa no disponible.
              </div>
            }
          </div>

          <!-- Footer -->
          <div
            class="bg-gray-50 dark:bg-gray-800 px-4 py-2 border-t border-gray-200 dark:border-gray-700"
          >
            <p class="text-xs text-gray-400 dark:text-gray-500 italic">
              Vista previa generada con el mismo formato del correo que se
              enviará.
            </p>
          </div>
        </div>
      </div>
    } @else {
      <!-- Empty state cuando no hay plantilla -->
      <div
        class="flex flex-col items-center justify-center h-full min-h-[200px] text-center px-4 rounded-xl border border-dashed border-gray-200 dark:border-gray-700"
      >
        <svg
          class="w-10 h-10 text-gray-300 dark:text-gray-600 mb-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        <p class="text-sm text-gray-400 dark:text-gray-500">
          Selecciona una plantilla para<br />ver la vista previa del correo.
        </p>
      </div>
    }
  </div>
</div>
